import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import RadioButtonGroup from "../../common/RadioButtonGroup";
import Row from "../../common/Row";
import AnderOnroerendZakelijkRechtAanvragerForm from "./AnderOnroerendZakelijkRechtAanvragerForm";
import EigendomsrechtAanvragerForm from "./EigendomsrechtAanvragerForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import ConfirmModal from "../../common/ConfirmModal";

import * as domainConstants from "../../../constants/DomainConstants";
import CopyZakelijkRechtButton from "./CopyZakelijkRechtButton";

class RechtOpLangdurigZakelijkRecht extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			selectedInfrastructuur: null,
			confirmModalIsOpen: false
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ selectedInfrastructuur: this.props.otherInfrastructuren.length > 1 ? null : this.props.otherInfrastructuren[0] });
	}

	handleOnClickCopyZakelijkRecht(event) {
		if (event.target.name === "infrastructuurToCopyId")
			return;
		const infrastructuur = this.state.selectedInfrastructuur;
		const infrastructuurIdToCopy = infrastructuur ? infrastructuur["id"] : null;
		if (infrastructuurIdToCopy) {
			this.setState({ confirmModalIsOpen: true });
		}
	}
	handleOnConfirmCopy() {
		const infrastructuur = this.state.selectedInfrastructuur;
		const infrastructuurIdToCopy = infrastructuur ? infrastructuur["id"] : null;
		if (infrastructuurIdToCopy) {
			this.props.onCopyZakelijkRecht(infrastructuurIdToCopy);
		}
		this.setState({ confirmModalIsOpen: false });
	}
	handleOnCancelCopy() {
		this.setState({ confirmModalIsOpen: false });
	}
	handleOnChangeSelectedInfrastructuur(event) {
		this.setState({ selectedInfrastructuur: this.props.otherInfrastructuren.find(x => x.id == event.target.value) });
	}
	render() {
		const {
			minimaleEisen,
			disabled,
			errors,
			onChange,
			color,
			fileTypes,
			mapDeleteFile,
			mapDropFiles,
			getFilesForDossierComponent,
			hasFilesForDossierComponent,
			langdurigZakelijkRechtTypes,
			aanvragers,
			fileSessionStarted,
			dossierType,
			validationMessageType,
			otherInfrastructuren
			} = this.props;

	const defaultAanvrager = aanvragers.length === 1 ? aanvragers[0] : null;

	const anderOnroerendZakelijkRecht =
		(<Row>
			<AnderOnroerendZakelijkRechtAanvragerForm
				langdurigZakelijkRechtTypes={langdurigZakelijkRechtTypes}
				aanvragers={aanvragers}
				disabled={disabled}
				onChange={onChange}
				minimaleEisen={minimaleEisen}
				color={color}
				mapDeleteFile={mapDeleteFile}
				mapDropFiles={mapDropFiles}
				getFilesForDossierComponent={getFilesForDossierComponent}
				fileTypes={fileTypes}
				fileSessionStarted={fileSessionStarted}
				errors={errors}
				validationMessageType={validationMessageType}
				defaultAanvrager={defaultAanvrager}
			/>
		</Row>);

	const eigendomsrecht = (<Row>
		<EigendomsrechtAanvragerForm
			aanvragers={aanvragers}
			disabled={disabled}
			onChange={onChange}
			minimaleEisen={minimaleEisen}
			color={color}
			mapDeleteFile={mapDeleteFile}
			mapDropFiles={mapDropFiles}
			getFilesForDossierComponent={getFilesForDossierComponent}
			fileTypes={fileTypes}
			fileSessionStarted={fileSessionStarted}
			errors={errors}
			validationMessageType={validationMessageType}
			defaultAanvrager={defaultAanvrager}
		/>
	</Row>);

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	const soortRecht = [{ value: "121450000", label: 'eigendomsrecht' }, { value: "121450001", label: 'een ander onroerend zakelijk recht' }];
	const title = dossierType === domainConstants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_NIEUWBOUW || dossierType === domainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_NIEUWBOUW ? "Beschikt de aanvrager over een eigendomstitel of een ander langdurig onroerend zakelijk recht op het perceel waarop de sportinfrastructuur wordt gebouwd?" : "Beschikt de aanvrager over een eigendomstitel of een ander langdurig onroerend zakelijk recht op het perceel waarop de sportinfrastructuur wordt gebouwd/gerenoveerd of zijn er sterke garanties dat de eigendomstitel of een zakelijk recht zullen worden verworven?";
	const titleWelkOnroerendZakelijkRecht = dossierType == domainConstants.DOSSIER_TYPE_AANVRAAG_BOVENLOKAAL_NIEUWBOUW || dossierType === domainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_NIEUWBOUW ? "Over welk zakelijk recht beschikt u op het perceel waarop de sportinfrastructuur wordt gebouwd?" : "Over welk zakelijk recht beschikt u op het perceel waarop de sportinfrastructuur wordt gerenoveerd?";
	let buttonNode = null;
	const hasOtherInfrastructuren = otherInfrastructuren.length > 0;
	const moreThenOneOtherInfrastructuur = otherInfrastructuren.length > 1;
	if (hasOtherInfrastructuren) {
		buttonNode = (<CopyZakelijkRechtButton
			selectedInfrastructuur={this.state.selectedInfrastructuur}
			moreThenOneOtherInfrastructuur={moreThenOneOtherInfrastructuur}
			otherInfrastructuren={otherInfrastructuren}
			disabled={disabled}
			onClickCopyZakelijkRecht={this.handleOnClickCopyZakelijkRecht}
			onChangeSelectedInfrastructuur={this.handleOnChangeSelectedInfrastructuur}
			alignRight />);
	}
	return (
		<Fieldset title={title}>
			<ConfirmModal
				hookToTop={false}
				isOpen={this.state.confirmModalIsOpen}
				title="Let op!"
				mainText="Controleer zorgvuldig of de gekopieerde informatie wel degelijk van toepassing is op deze infrastructuur."
				confirmAction={this.handleOnConfirmCopy}
				cancelAction={this.handleOnCancelCopy}
				confirmText="Kopieer"
				cancelText="Annuleer" />
			{hasOtherInfrastructuren && (
				<Row>
					{buttonNode}
				</Row>
			)}
			{hasOtherInfrastructuren && <br />}
			<RadioButtonGroup
				name={"heeftAanvragerLandurigZakelijkRecht"}
				value={minimaleEisen.heeftAanvragerLandurigZakelijkRecht}
				onChange={onChange}
				disabled={disabled}
				items={jaNee}
				horizontal
				validationMessage={errors ? errors.heeftAanvragerLandurigZakelijkRecht : ''}
				validationMessageType={validationMessageType}
				locked={((minimaleEisen.welkOnroerendZakelijkRecht === "121450000" || minimaleEisen.welkOnroerendZakelijkRecht == 121450000) && hasFilesForDossierComponent(domainConstants.ComponentName.BewijsEigendom)) || ((minimaleEisen.welkOnroerendZakelijkRecht === "121450001" || minimaleEisen.welkOnroerendZakelijkRecht == 121450001) && hasFilesForDossierComponent(domainConstants.ComponentName.BewijsZakelijkRecht))} />
			{minimaleEisen.heeftAanvragerLandurigZakelijkRecht === "true" || minimaleEisen.heeftAanvragerLandurigZakelijkRecht == true ?
				<div>
					<RadioButtonGroup
						name={"welkOnroerendZakelijkRecht"}
						value={minimaleEisen.welkOnroerendZakelijkRecht}
						onChange={onChange}
						disabled={disabled}
						items={soortRecht}
						horizontal
						label={titleWelkOnroerendZakelijkRecht}
						validationMessage={errors ? errors.welkOnroerendZakelijkRecht : ''}
						validationMessageType={validationMessageType}
						locked={((minimaleEisen.welkOnroerendZakelijkRecht === "121450000" || minimaleEisen.welkOnroerendZakelijkRecht == 121450000) && hasFilesForDossierComponent(domainConstants.ComponentName.BewijsEigendom)) || ((minimaleEisen.welkOnroerendZakelijkRecht === "121450001" || minimaleEisen.welkOnroerendZakelijkRecht == 121450001) && hasFilesForDossierComponent(domainConstants.ComponentName.BewijsZakelijkRecht))} />
					{minimaleEisen.welkOnroerendZakelijkRecht === "121450000" || minimaleEisen.welkOnroerendZakelijkRecht == 121450000 ?
						eigendomsrecht : minimaleEisen.welkOnroerendZakelijkRecht === "121450001" || minimaleEisen.welkOnroerendZakelijkRecht == 121450001 ? anderOnroerendZakelijkRecht : ""}
				</div> : ""}
			</Fieldset>
		);
	}
}

RechtOpLangdurigZakelijkRecht.propTypes = {
	minimaleEisen: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	color: PropTypes.string.isRequired,
	otherInfrastructuren: PropTypes.array.isRequired,
	fileTypes: PropTypes.object,
	mapDeleteFile: PropTypes.func.isRequired,
	mapDropFiles: PropTypes.func.isRequired,
	getFilesForDossierComponent: PropTypes.func.isRequired,
	hasFilesForDossierComponent: PropTypes.func.isRequired,
	langdurigZakelijkRechtTypes: PropTypes.array.isRequired,
	aanvragers: PropTypes.array.isRequired,
	fileSessionStarted: PropTypes.bool.isRequired,
	dossierType: PropTypes.number.isRequired,
	validationMessageType: PropTypes.string,
	onCopyZakelijkRecht: PropTypes.func.isRequired
};

export default RechtOpLangdurigZakelijkRecht;
